<style>
    .logo{
      max-height: 40px; 
      max-width:80px;
      transform: scale(0.7);
    }

    .logo-top-bar{
      max-height: 45px; 
      max-width:45px;
      /* transform: scale(1.7);       */
      /* border-style: solid;
      border-width: 0.1rem;
      border-color: #39a9dc; */

    }

    .itemselected{
      background-color: #002052;
      border-style: solid;
      border-width: 0em 0em 0em 0.3em;
      border-color: #ffd300;
    }
    .sidebaritems:hover{
      background-color: #42A5F5;
    }
    .sidebaritems{}

</style>
<template>
  <div v-if="this.value&&this.items">
    <v-toolbar
      app
      dark
      :fixed="true"
      :clipped-left="false"
      
      class="elevation-0"
      style="z-index: 0;background-color:transparent;background-image: linear-gradient(to right,  #002052,#002052);"
    >          
          <v-toolbar-side-icon  
            @click.stop="drawer=!drawer"
            
          ></v-toolbar-side-icon>
          <v-toolbar-title style="margin-left:-5px;" >
            
              <v-icon style="margin-right:5px;;margin-bottom:2px" >{{this.value.icon}}</v-icon>
              <span>{{this.value.title}}</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn  
            dark icon flat
            v-if="value.action"
            v-on:click="$emit('action',value.action.event)">
            <v-icon>{{value.action.icon}}</v-icon>
          </v-btn>
          <v-btn  
            v-for="(act,index) in fixedactions"  
            dark icon flat
            :key="index"
            v-on:click="$emit('fixedaction', act)">
            <v-icon>{{act.icon}}</v-icon>
          </v-btn>    

          <div v-if="user" style="margin-right:0.5rem">
            <v-icon small style="margin-bottom:0.1rem">accessibility</v-icon>
            {{user}}
          </div>
          <img 
            :src="title.img" 
            class="logo-top-bar "
            style="
              //background-color:white;
              //padding:0.2rem; 
              margin-left:1rem;
            "
          >

          <template v-slot:extension v-if="detailed">
            <v-tabs
              v-model="active"
              color="#002052"
              align-with-title
            >
              <v-tabs-slider color="yellow"></v-tabs-slider>

              <v-tab v-for="item in items" :key="item.title" @click="$emit('input', item)">
                <v-icon>{{ item.icon }}</v-icon> {{ item.title }}
              </v-tab>

            </v-tabs>
          </template>
    </v-toolbar>

    <v-navigation-drawer
      style="z-index:999;background-image: linear-gradient(#39a9dc,#39a9dc);"
      width="230px"
      dark
      v-model="drawer"
      :mini-variant.sync="mini"
      :fixed="true"
      class="blue darken-1 "
      app
    >
      <v-toolbar flat style="background-image:none;background-color:transparent" >
        <v-list class="pa-0 ">
          <v-list-tile avatar >
              <img 
                :src="title.img" 
                class="logo sidebaritems"
                style="margin-left:-10px;margin-right:5px"
              >
            <v-list-tile-content>
              <v-list-tile-title>{{title.title}}</v-list-tile-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-btn
                icon
                @click.stop="mini = !mini"
              >
                <v-icon>chevron_left</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-toolbar>
      <v-list class="pt-0" dense  style="background-image:none;background-color:transparent">
        <v-list-tile
          style="background-image:none"
          v-for="item in items"
          :key="item.title"
          @click="$emit('input', item)"
          @click.stop="mini = mini"
          v-bind:class="{itemselected: item.title==value.title}"
          
        >
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    
  </div>
</template>

<script>
  export default {
    props:{
      'value':Object,
      'title':Object,
      'items':Array,
      'startOpened':Boolean,
      'hide': Boolean,
      'detailed': Boolean,
      'user': String,
      'fixedactions': Array
    },
    data () {
      return {
        drawer:true,
        mini: false,
        right: null
      }
    },
    mounted(){
      this.drawer = (this.startOpened instanceof Boolean)?this.startOpened:true
      this.drawer = this.hide
    },

    watch:{
      hide(){
        this.drawer=this.hide
      }
    },

    computed :{
      active : function () {
        let act = 0
        for(let i in this.items){
          if(this.value && this.items[i])
          if(this.value.title == this.items[i].title)
            break
          act++
        }
        return act
      }
    }
  }
</script>
